module.exports = __webpack_public_path__ + "img/cp73-qrcode.90529ede.jpg";